export default __webpack_public_path__ + "assets/pdf/FT_ZN.081e0ddf.pdf";